import $ from 'jquery';
import Mustache from 'mustache';

import cookie from '../modules/cookies';

export default {
  init: function() {

    window.addEventListener('beforeunload', function() {
      /**
       * This event prevents IE11 from caching the entire
       * page and restoring it without firing the appropriate
       * events.
       */
    });

    var Basket = window.Basket = function() {

      var api = {},
          LANG = $('body').data('lang'),
          ajaxUrl = '/stage-ajax/dlcenterhandler?stage-language=' + LANG,
          currentPhase = 'notrunning',
          percentPerPoll = 0,
          pdfProgress = 0,
          dialogContext = $('.basket-list-container');


      /**
       * Starts the background task of generating pdf
       *
       */
      api.requestPdf = function() {

        $('.basket-request-container').hide();

        $(dialogContext).prop('disabled', 'true').addClass('loading');

        $.ajax(ajaxUrl, {
          data: {
            action: 'pdf'
          },
          cache: false,
          type: 'get',
          dataType: 'json',
          done: function(resp) {
            $(dialogContext).prop('disabled', 'false').removeClass('loading');
          },
          success: function(resp) {
            if(typeof resp === 'object' && resp) {

              if(resp.error) {
                $('.basket-request-container').show();
              } else if(resp.job) {
                //$.cookie('pdf-waiting', resp.job, {path: '/'});
                cookie.set('pdf-waiting', resp.job);
                currentPhase = 'waitingTask';
                pdfProgress = 0;
                poll();
              }
            }
          }
        });
      };

      /**
       * Hides basket dialog if it exists (equivalent to hiding download pdf button and showing generate pdf button)
       */
      function resetPdfState() {
        var dialog = $('#basket-dialog');

        if(dialog.length) {
          dialog.parent().removeClass('loading pdf-complete');
          dialog.remove();
          $('.basket-request-container').show();
        }
      }

      api.resetPdfState = resetPdfState;

      /**
       * Queries the background process periodically for progress reports.
       */
      function poll() {
        var jobid = cookie.get('pdf-waiting'), //$.cookie('pdf-waiting'),
            dialog = $('#basket-dialog'),
            context = dialogContext,
            interval = 2000; //2s

        if (jobid === 'null') {
          return;
        }

        if (!dialog.length) {

          var template = $('#basket-dialog-template').html();

          Mustache.parse(template); // optional, speeds up future uses

          var rendered = Mustache.render(template);

          dialog = $(rendered);

          context.append(dialog);

          dialog.find('.progress-abort').on('click', function() {
            cookie.remove('pdf-waiting');
            //$.cookie('pdf-waiting', null, {path: '/'});
            //dialog.remove();
            resetPdfState();
          });

        }

        if (!dialog.hasClass('started')) {
          dialog.removeClass('error').removeClass('success');
        }

        $.ajax(ajaxUrl, {
          type: 'post',
          data: {
            action: 'getpdf',
            jobid: jobid
          },
          dataType: 'json',
          success: function(data) {
            if (typeof data === 'object' && data) {
              var displayProgress = 0;
              switch(data.status) {
              case 'done':
                // delete process cookie
                cookie.remove('pdf-waiting');
                //$.cookie('pdf-waiting', null, {path: '/'});

                //Update indicators
                displayProgress = 100;
                dialog.find('.progress-text').text(displayProgress + '%');
                dialog.find('.progress-indicator').css({width: displayProgress + '%'});

                // do the default actions for default implementation
                dialog.removeClass('started').addClass('success');
                dialog.find('.dlcenter-dllink').attr('href', data.retdata.url).text(data.retdata.text);
                dialog.parent().removeClass('loading').addClass('pdf-complete');
                break;
              case 'running':
                var progress = Math.floor(parseFloat(data.retdata.progress) * 100);
                switch (currentPhase) {
                case 'waitingTask':
                  currentPhase = 'running';
                  break;
                case 'running':
                  if (data.retdata.phase && data.retdata.phase === 'pdf') {
                    currentPhase = 'pdf';
                    percentPerPoll = (45/data.params.pages.length) * 8;
                  }
                  break;
                case 'pdf':
                  pdfProgress += percentPerPoll;
                  break;
                }
                // displayProgress uses simulated or 'true' progress depending if bg task supports simulated one
                displayProgress = data.retdata.phase ? progress : Math.min(Math.floor(0.55*progress + pdfProgress), 99);
                dialog.find('.progress-text').text(displayProgress + '%');
                dialog.find('.progress-indicator').css({width: displayProgress + '%'});
                setTimeout(poll, interval);
                break;
              case 'failed':
                // show error
                cookie.remove('pdf-waiting');
                //$.cookie('pdf-waiting', null, {path: '/'});
                dialog.removeClass('started').addClass('error');
                break;
              default:
                setTimeout(poll, interval);
              }
            } else {
              setTimeout(poll, interval);
            }
          },
          error: function() {
            // show error
            cookie.remove('pdf-waiting');
            //$.cookie('pdf-waiting', null, {path: '/'});
            dialog.removeClass('started').addClass('error');
          }
        });
      }

      /**
       * Updates all .basket-count-number elements with the current count of basket items
       * And hides the generate pdf & empty list buttons, if there are no items
       * Takes singular/plural form of translations into account
       *
       * @param {Array} items - Array of basket items
       */
      function updateCount(items) {

        $('.basket-request-container').toggleClass('hidden', items.length === 0);
        $('.basket-request-container').toggleClass('singular', items.length === 1);
        $('.basket-request-container').toggleClass('plural', items.length !== 1);

        $('.basket-count-number').text(items.length);

        $('.basket .empty-list').toggleClass('hidden', items.length === 0);

      }

      /**
       * Updates all .basket-lists with the current basket items
       */
      function updateList() {
        var template = $('#basket-item-template').html(),
            list = $('.basket-list');

        //TODO: should maybe change this so that only added/removed are changed, instead of clearing whole list

        api.getItems(function(status, items) {

          if(status === 'success') {
            //Remove old children
            list.children().remove();

            Mustache.parse(template);

            //Update list with new info
            $.each(items, function(i, item) {
              //Render template
              var renderedItem = Mustache.render(template, item);
              list.append(renderedItem);
            });
          }else if(status === 'error') {
            //TODO
          }
        });
      }

      /**
       * Fetches items (with list data) from backend
       *
       * @param {function} callback - Optional callback function to run when done
       */
      api.getItems = function(callback) {
        $.ajax(ajaxUrl, {
          data: $.param({
            action: 'list'
          }),
          cache: false,
          type: 'get',
          success: function(resp) {

            if(typeof callback === 'function') {
              callback('success', resp);
            }
          },
          error: function(resp) {

            if(typeof callback === 'function') {
              callback('error', resp);
            }
          }
        });
      };

      /**
       * Adds items to basket
       * Supports bulk add
       *
       * @param {Array} items - Array of basket items to be added
       * @param {function} callback - Optional callback function to run when done
       */
      api.add = function(items, callback) {
        //Data done like this, because ajax page expexts the query string in the following format
        //action=add&items[]={'page':'cm-page://M2SWdU-UToyZ4bHDtj8QIg/'}
        $.ajax(ajaxUrl, {
          data: $.param({
            action: 'add',
            items: [JSON.stringify(items)]
          }),
          cache: false,
          type: 'get',
          success: function(resp) {
            updateCount(resp);
            updateList();
            resetPdfState();

            $('.basket-tools').addClass('in-basket');

            if(typeof callback === 'function') {
              callback('success', resp);
            }
          },
          error: function(resp) {

            if(typeof callback === 'function') {
              callback('error', resp);
            }
          }
        });
      };

      /**
       * Removes items from basket
       * Supports bulk remove
       *
       * @param {Array} items - Array of basket items to be removed
       * @param {function} callback - Optional callback function to run when done
       */
      api.remove = function(items, callback) {
        //Data done like this, because ajax page expexts the query string in the following format
        //action=remove&items[]={'page':'cm-page://M2SWdU-UToyZ4bHDtj8QIg/'}
        $.ajax(ajaxUrl, {
          data: $.param({
            action: 'remove',
            items: [JSON.stringify(items)]
          }),
          cache: false,
          type: 'get',
          success: function(resp) {

            updateCount(resp);
            updateList();
            resetPdfState();

            $('.basket-tools').removeClass('in-basket');

            if(typeof callback === 'function') {
              callback('success', resp);
            }
          },
          error: function(resp) {

            if(typeof callback === 'function') {
              callback('error', resp);
            }
          }
        });
      };

      /**
       * Empties the basket of all items
       *
       * @param {function} callback - Optional callback function to run when done
       */
      api.empty = function(callback) {
        $.ajax(ajaxUrl, {
          data: $.param({
            action: 'empty'
          }),
          cache: false,
          type: 'get',
          success: function(resp) {
            updateCount(resp);
            updateList();
            resetPdfState();

            $('.basket-tools').removeClass('in-basket');

            if(typeof callback === 'function') {
              callback('success', resp);
            }
          },
          error: function(resp) {

            if(typeof callback === 'function') {
              callback('error', resp);
            }
          }
        });
      };

      return api;

    }();

    $(document).on('click', '.basket-add', function(e) {

      var items = $(this).data('items');

      if(items) {
        e.preventDefault();
        Basket.add(items);
      }

    }).on('click', '.basket-remove', function(e) {

      var items = $(this).data('items');

      if(items) {
        e.preventDefault();
        Basket.remove(items);
      }

    }).on('click', '.basket-request-pdf', function(e) {
      e.preventDefault();

      if(!$(this).is('.loading')) {
        Basket.requestPdf();
      }

    }).on('click', '.dlcenter-dllink', function(e) {
      Basket.resetPdfState();

    }).on('click', '.basket-empty', function(e) {
      e.preventDefault();

      Basket.empty();
    });

  }
};
